
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "./DescriptionManager.css";

// const API = "https://grocerrybackend.vercel.app/api/descriptions";

// export default function DescriptionManager() {
//   const [items, setItems] = useState([]);
//   const [form, setForm] = useState({ title: "", description: "" });
//   const [editId, setEditId] = useState(null);
//   const [showForm, setShowForm] = useState(false);

//   // Modal
//   const [isModalOpen, setModalOpen] = useState(false);
//   const [modalData, setModalData] = useState({
//     title: "",
//     description: "",
//     id: null,
//   });

//   // Load all
//   const fetchItems = async () => {
//     const res = await axios.get(API);
//     setItems(res.data.data);
//   };

//   useEffect(() => {
//     fetchItems();
//   }, []);

//   // Input change
//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   // Create / Update
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!form.title) return alert("Enter title!");

//     if (editId) {
//       await axios.put(`${API}/${editId}`, form);
//       alert("Updated!");
//     } else {
//       await axios.post(API, form);
//       alert("Created!");
//     }

//     setForm({ title: "", description: "" });
//     setEditId(null);
//     fetchItems();
//   };

//   // Delete
//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete item?")) return;
//     await axios.delete(`${API}/${id}`);
//     fetchItems();
//   };

//   // Modal open
//   const openModal = (item) => {
//     setModalData({
//       title: item.title,
//       description: item.description,
//       id: item._id,
//     });
//     setModalOpen(true);
//   };

//   // Modal save
//   const saveModal = async () => {
//     await axios.put(`${API}/${modalData.id}`, {
//       title: modalData.title,
//       description: modalData.description,
//     });
//     setModalOpen(false);
//     fetchItems();
//   };

//   return (
//     <div className="desc-container">
//       {/* <h2>Description Manager</h2>

//       <button className="desc-add-btn" onClick={() => setShowForm(!showForm)}>
//         {showForm ? "Close Form" : "Add Description"}
//       </button> */}
//       <div className="desc-header-row">
//   <h2>Description Manager</h2>

//   <button className="desc-add-btn"
//     onClick={() => setShowForm(!showForm)}
//   >
//     {showForm ? "Close Form" : "Add Description"}
//   </button>
// </div>


//       {showForm && (
//         <form className="desc-form" onSubmit={handleSubmit}>
//           <input
//             type="text"
//             name="title"
//             placeholder="Title"
//             value={form.title}
//             onChange={handleChange}
//             className="desc-input"
//           />

//           <textarea
//             name="description"
//             placeholder="Description"
//             value={form.description}
//             onChange={handleChange}
//             className="desc-textarea"
//           />

//           <button className="desc-save-btn">
//             {editId ? "Update" : "Save"}
//           </button>
//         </form>
//       )}

//       <div className="desc-list">
//         {items.map((item) => (
//           <div key={item._id} className="desc-card">
//             <h3>{item.title}</h3>
//             <p>{item.description}</p>

//             <div className="desc-actions">
//               <button
//                 className="desc-edit-btn"
//                 onClick={() => openModal(item)}
//               >
//                 Edit
//               </button>

//               <button
//                 className="desc-delete-btn"
//                 onClick={() => handleDelete(item._id)}
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Modal */}
//       {isModalOpen && (
//         <div className="desc-modal-overlay">
//           <div className="desc-modal">
//             <h3>Edit Description</h3>

//             <input
//               type="text"
//               className="desc-input"
//               value={modalData.title}
//               onChange={(e) =>
//                 setModalData({ ...modalData, title: e.target.value })
//               }
//             />

//             <textarea
//               className="desc-textarea"
//               value={modalData.description}
//               onChange={(e) =>
//                 setModalData({ ...modalData, description: e.target.value })
//               }
//             />

//             <button className="desc-save-btn" onClick={saveModal}>
//               Update
//             </button>

//             <button
//               className="desc-cancel-btn"
//               onClick={() => setModalOpen(false)}
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }




import React, { useEffect, useState } from "react";
import axios from "axios";
// NOTE: All custom CSS imports have been removed.

const API = "https://grocerrybackend.vercel.app/api/descriptions";

export default function DescriptionManager() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", description: "" });
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);

  // Modal
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState({
    title: "",
    description: "",
    id: null,
  });

  // Load all
  const fetchItems = async () => {
    try {
      const res = await axios.get(API);
      setItems(res.data.data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  // Input change
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Create / Update
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title) return alert("Enter title!");

    try {
      if (editId) {
        await axios.put(`${API}/${editId}`, form);
        alert("Updated!");
      } else {
        await axios.post(API, form);
        alert("Created!");
      }
      
      setForm({ title: "", description: "" });
      setEditId(null);
      fetchItems();
    } catch (error) {
        console.error("Error submitting form:", error);
        alert(`Error: ${editId ? 'Updating' : 'Creating'} item failed.`);
    }
  };

  // Delete
  const handleDelete = async (id) => {
    if (!window.confirm("Delete item?")) return;
    try {
      await axios.delete(`${API}/${id}`);
      fetchItems();
    } catch (error) {
      console.error("Error deleting item:", error);
      alert("Error: Deleting item failed.");
    }
  };

  // Modal open
  const openModal = (item) => {
    setModalData({
      title: item.title,
      description: item.description,
      id: item._id,
    });
    setModalOpen(true);
  };

  // Modal save
  const saveModal = async () => {
    try {
      await axios.put(`${API}/${modalData.id}`, {
        title: modalData.title,
        description: modalData.description,
      });
      setModalOpen(false);
      fetchItems();
      alert("Item updated successfully!");
    } catch (error) {
        console.error("Error saving modal changes:", error);
        alert("Error: Updating item via modal failed.");
    }
  };

  return (
    // Main container (assuming it is wrapped in a main container elsewhere, otherwise consider adding the max-w-4xl wrapper back)
    <> 
      {/* Header Row */}
      <div className="flex justify-between items-center mb-4 sm:mb-6 pb-2 sm:pb-4 border-b border-blue-100">
        {/* Title size: text-xl on mobile, text-2xl on larger screens */}
        <h2 className="text-xl sm:text-2xl font-bold text-blue-600">
          Description Manager
        </h2>

        {/* Primary Button size: smaller padding and text on mobile */}
        <button
          className="px-3 py-1 sm:px-4 sm:py-2 text-sm sm:text-base bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition duration-150"
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? "Close Form" : "Add Description"}
        </button>
      </div>

      {/* Form */}
      {showForm && (
        <form className="flex flex-col gap-3 sm:gap-4 p-4 sm:p-5 mb-6 sm:mb-8 bg-blue-50 rounded-lg shadow-inner" onSubmit={handleSubmit}>
          
          {/* Input size: smaller padding and text on mobile (text-sm, px-3 py-2) */}
          <input
            type="text"
            name="title"
            placeholder="Title"
            value={form.title}
            onChange={handleChange}
            className="w-full px-3 py-2 text-sm sm:px-4 sm:py-2 sm:text-base border border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
            required
          />

          {/* Textarea size: smaller padding and text on mobile (text-sm, px-3 py-2) */}
          <textarea
            name="description"
            placeholder="Description"
            value={form.description}
            onChange={handleChange}
            className="w-full px-3 py-2 text-sm sm:px-4 sm:py-2 sm:text-base border border-blue-300 rounded-md min-h-[80px] sm:min-h-[100px] focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
          />

          {/* Save Button size: smaller padding and text on mobile (px-5 py-1.5, text-sm) */}
          <button className="px-5 py-1.5 text-sm sm:px-6 sm:py-2 sm:text-base bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 transition duration-150 self-start">
            {editId ? "Update" : "Save"}
          </button>
        </form>
      )}

      {/* Item List (Flexible Wrapping Layout) */}
      <div className="flex flex-wrap gap-4">
        {items.map((item) => (
          // Card padding reduced on mobile (p-3)
          <div key={item._id} className="w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(33.333%-0.666rem)] p-3 sm:p-4 border border-blue-200 rounded-lg shadow-md bg-white hover:shadow-lg transition duration-300 transform hover:-translate-y-0.5">
            
            {/* Card Title size: text-lg on mobile, text-xl on larger screens */}
            <h3 className="text-lg sm:text-xl font-semibold text-blue-600 mb-1 sm:mb-2 border-b border-blue-100 pb-1">
              {item.title}
            </h3>
            
            {/* Card text size: text-xs on mobile, text-sm on larger screens */}
            <p className="text-xs sm:text-sm text-gray-700 mb-3 sm:mb-4">
              {item.description}
            </p>

            {/* Actions */}
            <div className="flex justify-end space-x-2 sm:space-x-3">
              {/* Action Button size: text-xs, smaller padding on mobile (px-2 py-1) */}
              <button
                className="text-xs px-2 py-1 sm:px-3 sm:py-1 sm:text-sm bg-blue-100 text-blue-600 rounded-md border border-blue-300 hover:bg-blue-600 hover:text-white transition duration-150"
                onClick={() => openModal(item)}
              >
                Edit
              </button>

              <button
                className="text-xs px-2 py-1 sm:px-3 sm:py-1 sm:text-sm bg-red-500 text-white rounded-md hover:bg-red-600 transition duration-150"
                onClick={() => handleDelete(item._id)}
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && (
        // Modal Overlay
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50 p-4">
          
          {/* Modal Content size: max-w-sm on mobile */}
          <div className="bg-white p-5 sm:p-6 rounded-lg shadow-2xl w-full max-w-sm sm:max-w-md transform transition-all duration-300 scale-100">
            {/* Modal Title size: text-xl on mobile */}
            <h3 className="text-xl sm:text-2xl font-bold text-blue-600 mb-4 sm:mb-5">
              Edit Description
            </h3>

            {/* Modal Input size: text-sm, px-3 py-2 on mobile */}
            <input
              type="text"
              className="w-full mb-3 sm:mb-4 px-3 py-2 text-sm sm:px-4 sm:py-2 sm:text-base border border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={modalData.title}
              onChange={(e) =>
                setModalData({ ...modalData, title: e.target.value })
              }
            />

            {/* Modal Textarea size: text-sm, px-3 py-2 on mobile */}
            <textarea
              className="w-full mb-4 sm:mb-6 px-3 py-2 text-sm sm:px-4 sm:py-2 sm:text-base border border-blue-300 rounded-md min-h-[80px] sm:min-h-[100px] focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={modalData.description}
              onChange={(e) =>
                setModalData({ ...modalData, description: e.target.value })
              }
            />

            <div className="flex justify-end space-x-2 sm:space-x-3">
              {/* Modal Button size: text-sm, px-3 py-1.5 on mobile */}
              <button
                className="px-3 py-1.5 text-sm sm:px-4 sm:py-2 sm:text-base bg-gray-300 text-gray-800 font-semibold rounded-md hover:bg-gray-400 transition"
                onClick={() => setModalOpen(false)}
              >
                Cancel
              </button>
              
              <button className="px-3 py-1.5 text-sm sm:px-4 sm:py-2 sm:text-base bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 transition" onClick={saveModal}>
                Update
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}